export const COLLABORATION_WALLET_PATH = "/collaborations/wallet";
export const COLLABORATION_BUY_PATH = "/collaborations/buy";

/** Legacy URLs kept as redirects after the credits → collaborations rename. */
export const LEGACY_CREDITS_PATH = "/credits";
export const LEGACY_CREDITS_BUY_PATH = "/credits/buy";

export function isCollaborationWalletPath(pathname: string): boolean {
  return (
    pathname === COLLABORATION_WALLET_PATH ||
    pathname === COLLABORATION_BUY_PATH ||
    pathname === LEGACY_CREDITS_PATH ||
    pathname.startsWith(`${LEGACY_CREDITS_PATH}/`)
  );
}
